import {store} from '../components/Base/App';

/*export const translate = key => {
    let state = store.getState();
    let i18n = state.languages.i18n;

    return translate(key, i18n);
};*/

export const translate = (key,i18n) =>{

    let translate = i18n[key];

    if (translate == null && Object.keys(i18n).length != 0) {
        console.info("i18n with code:[" + key + "] is not found");
    }

    if(process.env.REACT_APP_ENV != 'production' && translate == undefined){
        return key;
    }

    return translate;
}


// WEBPACK FOOTER //
// ./src/utils/i18n.js